import { IFunnelChartData } from "@/components/charts/funnel.chart";
import { BarProps } from "recharts";

interface FunnelBarProps {
  props: BarProps;
  data: IFunnelChartData[];
}

export const FunnelBar: React.FC<FunnelBarProps> = ({ data, props }) => {
  const { fill, x = 0, y = 0, width = 150, height = 150, index } = props;
  if (typeof index !== "number") return null;
  const currentValue = data[index].value;
  const nextValue = data[index + 1]?.value || data[index].value;

  const rightHeight = Number(y) + height - (height * nextValue) / currentValue;
  const path = `
      M${Number(x)},${Number(y) + height} 
      L${Number(x)},${Number(y)} 
      Q${Number(x) + width / 2},${rightHeight} ${Number(x) + width},${rightHeight} 
      L${Number(x) + width},${Number(y) + height} 
      Z
    `;

  return <path d={path} fill={fill} />;
};
